import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "form", "messages", "submitBtn", "loading", "questions"]
  static values = { loading: String }

  connect() {
    if (this.hasMessagesTarget) {
      this.scrollToBottom()
    }
  }

  askPredefined(event) {
    const label = event.currentTarget.textContent.trim()
    const question = event.currentTarget.dataset.question

    // Show short label in visible input, send full question via hidden field
    this.inputTarget.value = label
    this.inputTarget.name = ""
    const hidden = document.createElement("input")
    hidden.type = "hidden"
    hidden.name = "content"
    hidden.value = question
    this.formTarget.appendChild(hidden)

    this.formTarget.requestSubmit()
  }

  submit() {
    if (this.inputTarget.value.trim() === "") return

    this.submitBtnTarget.disabled = true
    this.inputTarget.readOnly = true

    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.remove("hidden")
    }

    if (this.hasQuestionsTarget) {
      this.questionsTarget.classList.add("hidden")
    }

    if (this.hasMessagesTarget) {
      this.scrollToBottom()
    }
  }

  scrollToBottom() {
    this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight
  }
}
